import { render } from "./UserEmailChange.vue?vue&type=template&id=38c4b1d4"
import script from "./UserEmailChange.vue?vue&type=script&lang=js"
export * from "./UserEmailChange.vue?vue&type=script&lang=js"

import exportComponent from "/home/sam/kenban_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__